var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vks-welcome",
      attrs: { role: "region", "aria-labelledby": "vks-welcome-title" },
    },
    [
      _c("div", { staticClass: "vks-welcome-card" }, [
        _c("header", { staticClass: "vks-welcome-head" }, [
          _c("h2", { attrs: { id: "vks-welcome-title" } }, [
            _vm._v(_vm._s(_vm.welcomeTitle)),
          ]),
          _c("p", { staticClass: "vks-welcome-lead" }, [
            _vm._v(
              " Variant Sifter helps you explore genetic associations, credible sets, enrichment, and variant-to-gene links across a shared genomic locus. Stack section visualizers, filter each track, and compare variants that survive your cross-section criteria. "
            ),
          ]),
        ]),
        _c(
          "form",
          {
            staticClass: "vks-welcome-form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onSubmit.apply(null, arguments)
              },
            },
          },
          [
            _c("h3", { staticClass: "vks-welcome-form-title" }, [
              _vm._v("Start a new search"),
            ]),
            _c("div", { staticClass: "vks-welcome-fields" }, [
              _vm.tokenSearchMode
                ? _c(
                    "div",
                    {
                      staticClass: "vks-welcome-field vks-welcome-field--wide",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "vks-welcome-label",
                          attrs: { for: _vm.tokenInputId },
                        },
                        [_vm._v(" Token ")]
                      ),
                      _c("div", { staticClass: "vks-welcome-token-row" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accessToken,
                              expression: "accessToken",
                            },
                          ],
                          staticClass: "vks-welcome-input",
                          attrs: {
                            id: _vm.tokenInputId,
                            type: "text",
                            autocomplete: "off",
                            spellcheck: "false",
                            placeholder: "Paste access token",
                          },
                          domProps: { value: _vm.accessToken },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.accessToken = $event.target.value
                              },
                              _vm.onTokenInput,
                            ],
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "vks-welcome-token-fetch",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.metadataFetching || !_vm.accessToken.trim(),
                            },
                            on: { click: _vm.onFetchTokenMetadata },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.metadataFetching
                                    ? "Fetching…"
                                    : "Fetch metadata"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _vm._m(0),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "vks-welcome-field" }, [
                _c(
                  "label",
                  {
                    staticClass: "vks-welcome-label",
                    attrs: { for: _vm.phenotypeInputId },
                  },
                  [_vm._v(" Phenotype ")]
                ),
                _c("div", { staticClass: "vks-welcome-typeahead" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phenotypeQuery,
                        expression: "phenotypeQuery",
                      },
                    ],
                    staticClass: "vks-welcome-input",
                    attrs: {
                      id: _vm.phenotypeInputId,
                      type: "text",
                      autocomplete: "off",
                      placeholder: "Search phenotype",
                    },
                    domProps: { value: _vm.phenotypeQuery },
                    on: {
                      focus: function ($event) {
                        _vm.phenotypeListOpen = true
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.phenotypeQuery = $event.target.value
                        },
                        _vm.onPhenotypeInput,
                      ],
                    },
                  }),
                  _vm.phenotypeListOpen && _vm.phenotypeSuggestions.length
                    ? _c(
                        "div",
                        {
                          staticClass: "vks-welcome-suggestions",
                          attrs: { role: "listbox" },
                        },
                        _vm._l(_vm.phenotypeSuggestions, function (phenotype) {
                          return _c(
                            "button",
                            {
                              key: phenotype.name,
                              staticClass: "vks-welcome-suggestion",
                              attrs: { type: "button", role: "option" },
                              on: {
                                mousedown: function ($event) {
                                  $event.preventDefault()
                                  return _vm.selectPhenotype(phenotype)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "vks-welcome-suggestion-label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.phenotypeSuggestionLabel(phenotype)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.phenotypeSuggestionMeta(phenotype)
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "vks-welcome-suggestion-meta",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.phenotypeSuggestionMeta(
                                              phenotype
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
              !_vm.hideAncestry
                ? _c("div", { staticClass: "vks-welcome-field" }, [
                    _c(
                      "label",
                      {
                        staticClass: "vks-welcome-label",
                        attrs: { for: _vm.ancestrySelectId },
                      },
                      [_vm._v(" Ancestry ")]
                    ),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedAncestry,
                            expression: "selectedAncestry",
                          },
                        ],
                        staticClass: "vks-welcome-select",
                        attrs: { id: _vm.ancestrySelectId },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedAncestry = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.ancestryOptions, function (ancestry) {
                        return _c(
                          "option",
                          { key: ancestry, domProps: { value: ancestry } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.ancestryLabel(ancestry)) + " "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "vks-welcome-field vks-welcome-field--wide" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "vks-welcome-label",
                      attrs: { for: _vm.locusInputId },
                    },
                    [_vm._v(" Gene or variant ")]
                  ),
                  _c("div", { staticClass: "vks-welcome-typeahead" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.geneOrVariantQuery,
                          expression: "geneOrVariantQuery",
                        },
                      ],
                      staticClass: "vks-welcome-input",
                      attrs: {
                        id: _vm.locusInputId,
                        type: "text",
                        autocomplete: "off",
                        placeholder:
                          "e.g. PCSK9, rs11716727, chr1:155000000, chr1:100000-200000",
                      },
                      domProps: { value: _vm.geneOrVariantQuery },
                      on: {
                        focus: _vm.onGeneOrVariantFocus,
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.geneOrVariantQuery = $event.target.value
                          },
                          _vm.onGeneOrVariantInput,
                        ],
                      },
                    }),
                    _vm.geneListOpen && _vm.geneSuggestions.length
                      ? _c(
                          "div",
                          {
                            staticClass: "vks-welcome-suggestions",
                            attrs: {
                              role: "listbox",
                              "aria-label": "Gene suggestions",
                            },
                          },
                          _vm._l(_vm.geneSuggestions, function (gene) {
                            return _c(
                              "button",
                              {
                                key: gene,
                                staticClass:
                                  "vks-welcome-suggestion vks-welcome-suggestion--gene",
                                attrs: { type: "button", role: "option" },
                                on: {
                                  mousedown: function ($event) {
                                    $event.preventDefault()
                                    return _vm.selectGene(gene)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "vks-welcome-suggestion-label",
                                  },
                                  [_vm._v(" " + _vm._s(gene) + " ")]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _vm._m(1),
                ]
              ),
              _c("div", { staticClass: "vks-welcome-field" }, [
                _c(
                  "label",
                  {
                    staticClass: "vks-welcome-label",
                    attrs: { for: _vm.expandSelectId },
                  },
                  [_vm._v(" Region expand ")]
                ),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.regionExpandBp,
                        expression: "regionExpandBp",
                      },
                    ],
                    staticClass: "vks-welcome-select",
                    attrs: { id: _vm.expandSelectId },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.regionExpandBp = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.regionExpandOptions, function (option) {
                    return _c(
                      "option",
                      {
                        key: String(option.value),
                        domProps: { value: option.value },
                      },
                      [_vm._v(" " + _vm._s(option.label) + " ")]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm.resolvedRegionLabel
              ? _c("p", { staticClass: "vks-welcome-region-preview" }, [
                  _vm._v(" Region preview: "),
                  _c("strong", [_vm._v(_vm._s(_vm.resolvedRegionLabel))]),
                ])
              : _vm._e(),
            _vm.errorMessage
              ? _c(
                  "p",
                  {
                    staticClass: "vks-welcome-error",
                    attrs: { role: "alert" },
                  },
                  [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                )
              : _vm._e(),
            _c("footer", { staticClass: "vks-welcome-footer" }, [
              _c(
                "button",
                {
                  staticClass: "vks-welcome-import",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("import-session")
                    },
                  },
                },
                [_vm._v(" Import session ")]
              ),
              _c(
                "button",
                {
                  staticClass: "vks-welcome-submit",
                  attrs: { type: "submit", disabled: _vm.submitting },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.submitting ? "Resolving locus…" : "Start exploring"
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "vks-welcome-hint" }, [
      _vm._v(" GWAS-CE associations load with this token. Use "),
      _c("strong", [_vm._v("Fetch metadata")]),
      _vm._v(
        " to fill phenotype and ancestry when the token provides them; otherwise set those fields manually for KP companion layers. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "vks-welcome-hint" }, [
      _vm._v(
        " Genes, variants, and locations are converted to a genomic region for the locus view. Enter a location as "
      ),
      _c("strong", [_vm._v("chr:position")]),
      _vm._v(" (e.g. chr1:155000000), or a region as "),
      _c("strong", [_vm._v("chr:start-end")]),
      _vm._v(". "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }